/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.

// Feature/feature-module-hedin-common
import Article from '../../src/Feature/feature-module-hedin-common/components/Article';
import Banner from '../../src/Feature/feature-module-hedin-common/components/Banner';
import BlogRoutes from '../../src/Feature/feature-module-hedin-common/components/BlogRoutes';
import Blurb from '../../src/Feature/feature-module-hedin-common/components/Blurb';
import Card from '../../src/Feature/feature-module-hedin-common/components/Card';
import Carousel from '../../src/Feature/feature-module-hedin-common/components/Carousel';
import CarouselLegacy from '../../src/Feature/feature-module-hedin-common/components/CarouselLegacy';
import ContentBlock from '../../src/Feature/feature-module-hedin-common/components/ContentBlock';
import CookieAcceptance from '../../src/Feature/feature-module-hedin-common/components/CookieAcceptance';
import Divider from '../../src/Feature/feature-module-hedin-common/components/Divider';
import EmbeddedVideo from '../../src/Feature/feature-module-hedin-common/components/EmbeddedVideo';
import GoogleMaps from '../../src/Feature/feature-module-hedin-common/components/GoogleMaps';
import Header from '../../src/Feature/feature-module-hedin-common/components/Header';
import Image from '../../src/Feature/feature-module-hedin-common/components/Image';
import JssForm from '../../src/Feature/feature-module-hedin-common/components/JssForm';
import LanguageSwitcher from '../../src/Feature/feature-module-hedin-common/components/LanguageSwitcher';
import MetaTags from '../../src/Feature/feature-module-hedin-common/components/MetaTags';
import NavigationLinks from '../../src/Feature/feature-module-hedin-common/components/NavigationLinks';
import RichContentBlock from '../../src/Feature/feature-module-hedin-common/components/RichContentBlock';
import ScrollToTop from '../../src/Feature/feature-module-hedin-common/components/ScrollToTop';
import Splitter from '../../src/Feature/feature-module-hedin-common/components/Splitter';


// Feature/feature-module-jss-defaults
import GraphQLConnectedDemo from '../../src/Feature/feature-module-jss-defaults/components/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../../src/Feature/feature-module-jss-defaults/components/GraphQL-IntegratedDemo';
import GraphQLLayout from '../../src/Feature/feature-module-jss-defaults/components/GraphQL-Layout';
import StyleguideComponentParams from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-CustomRouteType';
import StyleguideFieldUsageCheckbox from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-FieldUsage-Text';
import StyleguideLayout from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Layout';
import StyleguideLayoutReuse from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Layout-Reuse';
import StyleguideLayoutTabs from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Layout-Tabs';
import StyleguideLayoutTabsTab from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Layout-Tabs-Tab';
import StyleguideMultilingual from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Multilingual';
import StyleguideRouteFields from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-RouteFields';
import StyleguideSection from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Section';
import StyleguideSitecoreContext from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-SitecoreContext';
import StyleguideTracking from '../../src/Feature/feature-module-jss-defaults/components/Styleguide-Tracking';


// Project/ford-to-go
import CarCarousel from '../../src/Project/ford-to-go/components/CarCarousel';
import CarCheckoutForm from '../../src/Project/ford-to-go/components/CarCheckoutForm';
import CarInformation from '../../src/Project/ford-to-go/components/CarInformation';
import CarList from '../../src/Project/ford-to-go/components/CarList';
import CarOptions from '../../src/Project/ford-to-go/components/CarOptions';
import CarSummary from '../../src/Project/ford-to-go/components/CarSummary';
import FAQ from '../../src/Project/ford-to-go/components/FAQ';
import FordFooter from '../../src/Project/ford-to-go/components/FordFooter';
import Form from '../../src/Project/ford-to-go/components/Form';
import HeroCarousel from '../../src/Project/ford-to-go/components/HeroCarousel';
import ImageTextsLinks from '../../src/Project/ford-to-go/components/ImageTextsLinks';
import Navigation from '../../src/Project/ford-to-go/components/Navigation';
import NotFound from '../../src/Project/ford-to-go/components/NotFound';
import PuffBullets from '../../src/Project/ford-to-go/components/PuffBullets';
import Resellers from '../../src/Project/ford-to-go/components/Resellers';
import SellProcess from '../../src/Project/ford-to-go/components/SellProcess';
import StickyHeader from '../../src/Project/ford-to-go/components/StickyHeader';
import ThankYou from '../../src/Project/ford-to-go/components/ThankYou';
import ThankYouGTM from '../../src/Project/ford-to-go/components/ThankYouGTM';


const components = new Map();

// Feature/feature-module-hedin-common
components.set('Article', Article);
components.set('Banner', Banner);
components.set('BlogRoutes', BlogRoutes);
components.set('Blurb', Blurb);
components.set('Card', Card);
components.set('Carousel', Carousel);
components.set('CarouselLegacy', CarouselLegacy);
components.set('ContentBlock', ContentBlock);
components.set('CookieAcceptance', CookieAcceptance);
components.set('Divider', Divider);
components.set('EmbeddedVideo', EmbeddedVideo);
components.set('GoogleMaps', GoogleMaps);
components.set('Header', Header);
components.set('Image', Image);
components.set('JssForm', JssForm);
components.set('LanguageSwitcher', LanguageSwitcher);
components.set('MetaTags', MetaTags);
components.set('NavigationLinks', NavigationLinks);
components.set('RichContentBlock', RichContentBlock);
components.set('ScrollToTop', ScrollToTop);
components.set('Splitter', Splitter);


// Feature/feature-module-jss-defaults
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Tracking', StyleguideTracking);


// Project/ford-to-go
components.set('CarCarousel', CarCarousel);
components.set('CarCheckoutForm', CarCheckoutForm);
components.set('CarInformation', CarInformation);
components.set('CarList', CarList);
components.set('CarOptions', CarOptions);
components.set('CarSummary', CarSummary);
components.set('FAQ', FAQ);
components.set('FordFooter', FordFooter);
components.set('Form', Form);
components.set('HeroCarousel', HeroCarousel);
components.set('ImageTextsLinks', ImageTextsLinks);
components.set('Navigation', Navigation);
components.set('NotFound', NotFound);
components.set('PuffBullets', PuffBullets);
components.set('Resellers', Resellers);
components.set('SellProcess', SellProcess);
components.set('StickyHeader', StickyHeader);
components.set('ThankYou', ThankYou);
components.set('ThankYouGTM', ThankYouGTM);


export default function componentFactory(componentName) {
  return components.get(componentName);
};
